import {createSelector} from 'reselect';

import {AppState} from './../../../store';

export const commonSelector = (state: AppState) => state.common;

export const srpSelector = (state: AppState) => state.srp;

export const srpSelectorFn = createSelector(srpSelector, item => item);

export const srpDataSelectorFn = createSelector(srpSelectorFn, item => item.srpData);

export const srpOfferDataSelectorFn = createSelector(srpSelectorFn, item => item.srpOfferData);

export const srpConfigSelectorFn = createSelector(srpSelectorFn, item => item.srpConfig);

export const hasDataSelectorFn = createSelector(srpSelectorFn, item => item.hasData);

export const isSrpLoadingSelectorFn = createSelector(srpSelectorFn, item => item.isLoading);

export const cityMetaInfoSelectorFn = createSelector(
  srpDataSelectorFn,
  item => item.city_meta_info,
);

export const appliedFilterSelectorFn = createSelector(srpConfigSelectorFn, item => item.filter);

export const topLocationsListSelectorFn = createSelector(cityMetaInfoSelectorFn, item => item.tl);

export const overrankVhidSelectorFn = createSelector(
  srpConfigSelectorFn,
  item => item.overriderankvhids,
);

export const getTopLocationNameSelectorFn = createSelector(
  topLocationsListSelectorFn,
  (_, id: string) => id,
  (item, id) => {
    if (item && item.length > 0) item.find(subItem => subItem.id === id);
    return null;
  },
);

export const staticLocationsVoyagerIdsSelectorFn = createSelector(cityMetaInfoSelectorFn, item =>
  item && item.lli ? item.lli : {},
);

export const getLocationIdSelectorFn = createSelector(
  staticLocationsVoyagerIdsSelectorFn,
  (_, name: string) => name,
  (item, name) => {
    if (item && Object.keys(item).length > 0)
      Object.keys(item).find(itemKey => item[itemKey] === name);
    return null;
  },
);

export const hotelChainListSelectorFn = createSelector(cityMetaInfoSelectorFn, item => {
  return item && item.hcl && item.hcl.length > 0 ? item.hcl.filter(item => item) : [];
});

export const staticFilterLocationsListSelectorFn = createSelector(cityMetaInfoSelectorFn, item => {
  return item && item.dsl && Array.isArray(item.dsl)
    ? item.dsl.map(staticLocationsData => ({
        name: staticLocationsData.n,
        count: staticLocationsData.ahc,
      }))
    : [];
});

export const staticFilterLocationsListSelector = createSelector(
  [staticFilterLocationsListSelectorFn, staticLocationsVoyagerIdsSelectorFn],
  (locationFilterCheckboxList, staticLocationsNamesIdMap) => {
    return {
      locationFilterCheckboxList,
      staticLocationsNamesIdMap,
    };
  },
);
